<template>
  <v-snackbar v-model="snackbar" :bottom="true" :left="true" :multi-line="true" :right="false" :timeout="7000"
    :top="false" :vertical="false">
    {{ message }}
    <v-btn color="primary" flat aria-label="Close" @click="snackbar = false">
      {{ $t('alert.close') }}
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: "AlertSnackbar",
  props: {
    open: {
      type: Number,
      required: true,
      default: 0,
      validator: function(value) {
        return typeof value === "number";
      }
    },
    message: {
      type: String,
      required: true,
      default: "en",
      validator: function(value) {
        return typeof value === "string";
      }
    }
  },
  watch: {
    open(newval, oldval) {
      if (newval != oldval) {
        this.snackbar = true;
      }
    }
  },
  computed: {},
  methods: {},
  data() {
    return {
      snackbar: false
    };
  },
  // `i18n` option
  i18n: {
    messages: {
      en: {
        alert: {
          close: "Close"
        }
      },
      fr: {
        alert: {
          close: "Fermer"
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
